import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { headerLinks } from "../library/nav-links";

const StyledMobileSideNav = styled.div`
  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  ul.service-links {
    margin: 1rem 0 0 1rem;
  }

  ul.cannabis-links {
    margin-left: 2rem;
  }

  ul.main-links > li {
    border-bottom: 1px solid var(--light-gray);
    padding: 1rem 0;

    &:last-child {
      border: none;
    }
  }
`;

const MobileSideNav = ({
  setIsDropdownNav,
  isDropdownNav,
  setIsSecondaryLinks,
  isSecondaryLinks,
}) => {
  return (
    <StyledMobileSideNav>
      <ul className="main-links">
        {headerLinks.map((link) => (
          <li
            key={link.title}
            className="poppins-500"
            onClick={() => link.dropdownLinks && setIsDropdownNav(true)}
          >
            <Link to={link.href ? link.href : "/"}>{`${link.title}
              ${
                link.dropdownLinks ? (isDropdownNav ? " –" : " +") : ""
              }`}</Link>
            {link.dropdownLinks && isDropdownNav && (
              <>
                <ul className="service-links">
                  {link.dropdownLinks.map((link) => (
                    <li key={link.text} className="poppins-300 body-sm">
                      {link.href ? (
                        <Link to={link.href}>– {link.text}</Link>
                      ) : (
                        <div
                          className="hover"
                          onClick={() => setIsSecondaryLinks(!isSecondaryLinks)}
                        >
                          – {link.text}
                        </div>
                      )}
                    </li>
                  ))}
                  {isSecondaryLinks && (
                    <ul className="cannabis-links">
                      {isSecondaryLinks &&
                        link.dropdownLinks
                          .filter((link) => link.links)
                          .map((link) => link.links)[0]
                          .map((link) => (
                            <li key={link.text} className="poppins-300 body-sm">
                              <Link to={link.href}>– {link.text}</Link>
                            </li>
                          ))}
                    </ul>
                  )}
                </ul>
              </>
            )}
          </li>
        ))}
      </ul>
    </StyledMobileSideNav>
  );
};

export default MobileSideNav;
